import { FC, memo, ReactNode, useMemo, useState } from 'react'
import {
  ChangeColumn,
  FilterInput,
  Icon,
  Input,
  MarketSelectorWrap,
  PairColumn,
  PriceColumn,
  SymbolArrowDown,
  SymbolListContent,
  SymbolListHeader,
  SymbolListWrap,
  SymbolsDropdownWrap,
} from './style'
import { IconArrowDown } from 'components/Icons'
import Iconfont from 'components/Iconfont'
import { t } from 'i18next'
import { MarketItem } from './MarketItem'
import { CombinedSymbol } from 'utils/symbols'
import { useFastConvertSymbols } from 'store/convert/hooks'
import { ConvertItem } from './ConvertItem'
import { useMarketDrawer } from 'components/MarketDrawer'
import useWindow from 'hooks/useWindow'

export const MarketSelector: FC<{
  children: ReactNode
  symbols: CombinedSymbol[]
  hideDownIcon?: boolean
}> = memo(({ children, symbols, hideDownIcon }) => {
  const { open: openDrawer, close: closeDrawer, visible } = useMarketDrawer()

  const [searchKey, setSearchKey] = useState('')
  const fastConvert = useFastConvertSymbols()

  const unionSymbols = useMemo<Array<CombinedSymbol>>(() => {
    if (!searchKey) {
      return symbols
    }
    if (!symbols?.length) {
      return []
    }
    return symbols.filter((item: CombinedSymbol) => {
      return item.name
        .toLocaleLowerCase()
        .includes(searchKey.toLocaleLowerCase())
    })
  }, [symbols, searchKey])

  const filterConvert = useMemo(() => {
    if (!searchKey) {
      return fastConvert
    }
    return fastConvert.filter((item) =>
      `${item.baseName}/${item.quoteName}`
        .toLocaleLowerCase()
        .includes(searchKey.toLocaleLowerCase()),
    )
  }, [searchKey, fastConvert])

  return (
    <MarketSelectorWrap onMouseMove={openDrawer} onMouseLeave={closeDrawer}>
      {children}
      {!hideDownIcon && (
        <SymbolArrowDown visible={visible ? '1' : '2'}>
          <IconArrowDown />
        </SymbolArrowDown>
      )}
      {visible ? (
        <SymbolsDropdownWrap className="market-select">
          <FilterInput>
            <Icon>
              <Iconfont name="icon-Search" size={16} />
            </Icon>
            <Input
              placeholder={t('market-selector-search')}
              onChange={(event) => {
                setSearchKey(event.target.value)
              }}
            />
          </FilterInput>
          <SymbolListWrap>
            <SymbolListHeader>
              <PairColumn>Pair</PairColumn>
              <PriceColumn>Last Price</PriceColumn>
              <ChangeColumn>Change</ChangeColumn>
            </SymbolListHeader>
            <SymbolListContent>
              {unionSymbols.map((symbol) => (
                <MarketItem item={symbol as CombinedSymbol} key={symbol.id} />
              ))}
              {filterConvert.map((item) => (
                <ConvertItem key={item.tokenId} item={item} />
              ))}
            </SymbolListContent>
          </SymbolListWrap>
        </SymbolsDropdownWrap>
      ) : null}
    </MarketSelectorWrap>
  )
})
